import tinycolor from 'tinycolor2';

import { palette } from './palette';
import type { CoreTokens } from './tokens';

export function generateCoreTokens(
  color: string,
  otherColor: string
): CoreTokens {
  const white = tinycolor(palette.white);
  const dark = tinycolor(palette.steel900);
  const main = tinycolor(color);
  const secondary = tinycolor(otherColor);

  return {
    primary: {
      white: white.toHexString(),
      translucent: tinycolor.mix(white, main, 5).toHexString(),
      hint: tinycolor.mix(white, main, 12).toHexString(),
      soft: tinycolor.mix(white, main, 25).toHexString(),
      light: tinycolor.mix(white, main, 42).toHexString(),
      hazy: tinycolor.mix(white, main, 57).toHexString(),
      muted: tinycolor.mix(white, main, 75).toHexString(),
      balanced: tinycolor.mix(white, main, 90).toHexString(),
      main: main.toHexString(),
      deep: main.darken(15).saturate(2).toHexString(),
    },
    secondary: {
      white: white.toHexString(),
      translucent: tinycolor.mix(white, secondary, 5).toHexString(),
      hint: tinycolor.mix(white, secondary, 12).toHexString(),
      soft: tinycolor.mix(white, secondary, 25).toHexString(),
      light: tinycolor.mix(white, secondary, 42).toHexString(),
      hazy: tinycolor.mix(white, secondary, 57).toHexString(),
      muted: tinycolor.mix(white, secondary, 75).toHexString(),
      balanced: tinycolor.mix(white, secondary, 90).toHexString(),
      main: secondary.toHexString(),
      deep: secondary.darken(15).saturate(2).toHexString(),
    },
    border: {
      soft: tinycolor.mix(white, main, 25).toHexString(),
      softBlue: tinycolor.mix(white, main, 25).toHexString(),
      light: tinycolor.mix(white, main, 42).toHexString(),
      faint: tinycolor.mix(white, main, 58).toHexString(),
      muted: tinycolor.mix(white, main, 75).toHexString(),
      main: tinycolor.mix(white, main, 90).toHexString(),
      active: main.toHexString(),
    },
    background: {
      translucent: palette.navy10,
      hint: palette.navy25,
      soft: palette.navy50,
      light: palette.navy75,
      muted: palette.navy300,
      main: palette.navy500,
      faint: palette.blue10,
      success: palette.green50,
    },
    text: {
      white: tinycolor.mostReadable(main, [white, dark]).toHexString(),
      hazy: palette.grey300,
      faint: palette.grey400,
      muted: palette.grey500,
      balanced: palette.grey600,
      main: palette.grey700,
      dark: palette.grey900,
    },
    states: {
      hintInfo: palette.blue25,
      hintError: palette.red10,
      softInfo: palette.blue50,
      error: palette.red500,
      default: palette.blue500,
      disabled: palette.blue300,
      hover: palette.blue600,
      success: palette.green700,
    },
  };
}
